var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRigtArrowPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_1176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1589 7.42935C12.4698 7.74027 12.4698 8.25973 12.1589 8.57145L4.98493 15.7638C4.67002 16.0787 4.15933 16.0787 3.84523 15.7638C3.53032 15.4489 3.53032 14.9374 3.84523 14.6225L10.4493 8.00003L3.84443 1.37834C3.52953 1.06264 3.52953 0.551946 3.84443 0.236245C4.15933 -0.0786594 4.67002 -0.0786594 4.98413 0.236245L12.1589 7.42935Z",
    fill: "#9C0FDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_1176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigtArrowPink);
export default __webpack_public_path__ + "static/media/rigt-arrow-pink.e61f176e3b72ddd7662bbef69dd7cfab.svg";
export { ForwardRef as ReactComponent };